
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { apiShopLists, apiShopNumberChartData } from "@/api/shop";
import { copyClipboard } from "@/utils/util";
import * as echarts from "echarts";

@Component({
  components: {},
})
export default class ShopMoneyLog extends Vue {
  searchObj: any = {
    shop_id: "",
    start_time: "",
    end_time: "",
    page_size: 9,
    page_no: 1,
  };
  count: number = 0;
  time: any[] = [];
  shopList: any[] = [];
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  chartsData: any[] = [];

  orderTransferTableSettlementChartsData: any[] = [{}];

  loading: boolean = false;
  moneyLogCharts: any[] = [];

  handleSearch() {
    this.searchObj.page_no = 1;
    this.getShopNumberChartData();
  }
  reset() {
    this.searchObj = {
      shop_id: "",
      start_time: "",
      end_time: "",
    };
    this.time = [];
    this.getShopNumberChartData();
  }
  changeDate() {
    if (!this.time || !this.time.length) {
      this.searchObj.start_time = "";
      this.searchObj.end_time = "";
    } else {
      this.searchObj.start_time = this.time[0];
      this.searchObj.end_time = this.time[1];
    }
  }
  changePage(page: number) {
    this.searchObj.page_no = page;
    this.getShopNumberChartData();
  }
  async getShopList() {
    let res = await apiShopLists({ page_size: 9999 });
    this.shopList = res.lists;
  }

  async getShopNumberChartData() {
    this.loading = true;
    try {
      let res = await apiShopNumberChartData({
        sid: this.searchObj.shop_id,
        start_time: this.searchObj.start_time,
        end_time: this.searchObj.end_time,
        page_size: this.searchObj.page_size,
        page_no: this.searchObj.page_no,
      });
      this.count = res.count || 0;
      this.chartsData = res.lists || [];
      this.$nextTick(() => {
        this.renderShopMoneyLogCharts();
      });
    } catch (error) {
      console.error("获取商户资金图表失败:", error);
    } finally {
      this.loading = false;
    }
  }

  renderShopMoneyLogCharts() {
    this.disposeMoneyLogCharts();
    this.chartsData.forEach((chartItem: any, index: number) => {
      const chartDom: any = document.getElementById(
        "shopMoneyLogChart" + index,
      );
      if (!chartDom) {
        return;
      }

      const existingChart = echarts.getInstanceByDom(chartDom);
      if (existingChart) {
        existingChart.dispose();
      }
      const dateList = this.getChartDateList(chartItem);
      const series = this.getChartSeries(chartItem, dateList);
      const chart = echarts.init(chartDom);
      chart.setOption({
        title: [
          {
            text: chartItem.shop_name,
            top: 10,
            textStyle: {
              fontSize: 18,
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: 45,
          data: series.map((item: any) => item.name),
        },
        grid: {
          top: 90,
          left: 48,
          right: 36,
          bottom: 40,
        },
        xAxis: {
          type: "category",
          data: dateList,
        },
        yAxis: {
          type: "value",
        },
        series,
      });

      chart.on("click", (params: any) => {
        const text =
          params.componentType === "title"
            ? params.event.target.style.text
            : params.value;
        copyClipboard(text)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch((err) => {
            this.$message.error("复制失败");
            console.log(err);
          });
      });

      this.moneyLogCharts.push(chart);
    });
  }

  getChartDateList(chartItem: any) {
    const dateSet = new Set<string>();
    const data = chartItem.data || [];
    const seriesList = data.filter((item: any) => this.isChartSeriesItem(item));
    console.log(
      "🚀 ~ ShopMoneyLog ~ getChartDateList ~ seriesList:",
      seriesList,
    );

    if (seriesList.length) {
      seriesList.forEach((seriesItem: any) => {
        this.getChartPointList(seriesItem).forEach((point: any) => {
          const date = this.getChartPointDate(point);
          if (date) {
            dateSet.add(date);
          }
        });
      });
    } else {
      data.forEach((point: any) => {
        const date = this.getChartPointDate(point);
        if (date) {
          dateSet.add(date);
        }
      });
    }

    return Array.from(dateSet).sort();
  }

  getChartSeries(chartItem: any, dateList: string[]) {
    const data = chartItem.data || [];
    const seriesList = data.filter((item: any) => this.isChartSeriesItem(item));

    if (seriesList.length) {
      return seriesList.map((seriesItem: any, index: number) => {
        const dataMap = new Map(
          this.getChartPointList(seriesItem).map((point: any) => [
            this.getChartPointDate(point),
            this.getChartDataValue(point),
          ]),
        );
        return this.getLineSeriesOption(
          seriesItem.title ||
            seriesItem.name ||
            seriesItem.label ||
            `数据${index + 1}`,
          dateList,
          dataMap,
        );
      });
    }

    const valueKeys = this.getChartValueKeys(data);
    return valueKeys.map((key: string) => {
      const dataMap = new Map(
        data.map((point: any) => [this.getChartPointDate(point), point[key]]),
      );
      return this.getLineSeriesOption(
        this.getChartValueName(key),
        dateList,
        dataMap,
      );
    });
  }

  getLineSeriesOption(
    name: string,
    dateList: string[],
    dataMap: Map<any, any>,
  ) {
    return {
      name,
      data: dateList.map((date: string) =>
        dataMap.has(date) ? dataMap.get(date) : 0,
      ),
      type: "line",
      smooth: true,
      itemStyle: {
        borderWidth: 2,
        borderColor: "transparent",
      },
      emphasis: {
        scale: true,
        focus: "series",
      },
    };
  }

  isChartSeriesItem(item: any) {
    return (
      Array.isArray(item.data) ||
      Array.isArray(item.date_list) ||
      Array.isArray(item.list) ||
      Array.isArray(item.lists)
    );
  }

  getChartPointList(seriesItem: any) {
    return (
      seriesItem.data ||
      seriesItem.date_list ||
      seriesItem.list ||
      seriesItem.lists ||
      []
    );
  }

  getChartPointDate(point: any) {
    return point?.k;
  }

  getChartValueKeys(data: any[]) {
    const ignoreKeys = ["date", "time_date", "time", "name", "title", "label"];
    const firstRow = data.find((item: any) => item && typeof item === "object");
    if (!firstRow) {
      return [];
    }
    return Object.keys(firstRow).filter(
      (key) =>
        !ignoreKeys.includes(key) &&
        (typeof firstRow[key] === "number" || !isNaN(Number(firstRow[key]))),
    );
  }

  getChartValueName(key: string) {
    const nameMap: any = {
      value: "数值",
      num: "数量",
      count: "数量",
      money: "金额",
    };
    return nameMap[key] || key;
  }

  getChartDataValue(dataItem: any) {
    if (!dataItem) {
      return 0;
    }
    if (dataItem.v) {
      return dataItem.v;
    }
    return 0;
  }

  disposeMoneyLogCharts() {
    this.moneyLogCharts.forEach((chart: any) => {
      chart.dispose();
    });
    this.moneyLogCharts = [];
  }

  beforeDestroy() {
    this.disposeMoneyLogCharts();
  }

  async mounted() {
    let start_time = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    let end_time = new Date(new Date().getTime()).toISOString().split("T")[0];
    this.searchObj.start_time = start_time;
    this.searchObj.end_time = end_time;
    this.time = [start_time, end_time];
    await this.getShopList();
    await this.getShopNumberChartData();
  }
}
